import { render, staticRenderFns } from "./AddNewField.vue?vue&type=template&id=2af37298&scoped=true&"
import script from "./AddNewField.vue?vue&type=script&lang=js&"
export * from "./AddNewField.vue?vue&type=script&lang=js&"
import style0 from "./AddNewField.vue?vue&type=style&index=0&id=2af37298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af37298",
  null
  
)

export default component.exports